module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-6.b08ceee7.png";